import { filter, sortBy, values } from 'ramda';
import type { RootState } from 'reactApp/store';
import { createSelector } from 'reselect';

import { getBillingDataLoadingState } from './billingData.selectors';
import type { BillingDataReceivedGift } from './billingData.types';

// tempexp_16481-next-line
const AUTOUPLOAD_10TB_GIFT_ID = 'G10T_single_quota_2023';
const notDiscount = (gift: BillingDataReceivedGift) => !gift.discount && gift.id !== AUTOUPLOAD_10TB_GIFT_ID;
const isDiscount = (gift: BillingDataReceivedGift) => !!gift.discount;
const getBillingDataRoot = (state: RootState) => state.billingData;
const getGifts = createSelector(getBillingDataRoot, (state) => state.receivedGifts);
const getRawGiftsList = createSelector(getBillingDataRoot, (state) => state.rawBillingData.data.gift_received);
const filterNonDiscountGifts = createSelector(getGifts, (list) => list && filter(notDiscount, list));
const filterDiscountGifts = createSelector(getGifts, (list) => list && filter(isDiscount, list));
const sortReceivedGiftsByStart = createSelector(filterNonDiscountGifts, (list) => sortBy(({ start }) => start, values(list)));
const getDiscountGiftList = createSelector(filterDiscountGifts, values);
const getDiscountGiftByProductId = createSelector(
    getDiscountGiftList,
    (_, productId) => productId,
    (discountGifts, productId) => discountGifts.find((item) => productId === item.discount?.web)
);
// tempexp_16481-start
const hasAutoupload10TbGift = createSelector(getRawGiftsList, (list) => {
    return Boolean(Object.values(list).find((item) => item.giftible.product === AUTOUPLOAD_10TB_GIFT_ID));
});
// tempexp_16481-end
export const BillingDataReceivedGiftsSelectors = {
    getRawGiftsList,
    sortReceivedGiftsByStart,
    getDiscountGiftList,
    getReceivedGiftsLoadingState: getBillingDataLoadingState,
    getDiscountGiftByProductId,
    hasAutoupload10TbGift,
} as const;
